import { inject, reflectComponentType } from "@angular/core";
import { DisableReplacementDirective } from "./disable-replacement.directive";
import { has } from "lodash";
import { ReplaceableConfigService } from "../../services/replaceable-config.service";


export function ReplaceableComponent() {
    return function (target: any) {
      // Dynamically add logic to lifecycle methods
      const lifecycleMethods = [
        'ngOnInit',
        'ngOnDestroy',
        'ngAfterViewInit',
        'ngAfterContentInit',
        'ngAfterContentChecked',
        'ngAfterViewChecked',
        'ngDoCheck',
        'ngOnChanges',
      ];
  
      lifecycleMethods.forEach((methodName) => {
        if (typeof target.prototype[methodName] === 'function') {
          const originalMethod = target.prototype[methodName];
  
          target.prototype[methodName] = function (...args: any[]) {
            if (!this['isComponentReplaced']) {
              originalMethod.apply(this, args); // Call original method
            } 
          };
        } 
      });
     /// componentDescriptors [component selector. component class name, component class]
     Object.defineProperty(target.prototype, 'componentDescriptors', {
      get: function() {
        const originalComponentType = this.constructor;
        const originalMetadata = reflectComponentType(originalComponentType as any);
        if (!originalMetadata) {
          throw new Error('Component metadata not found.');
        }
        return [
          originalMetadata.selector,
          originalMetadata.type.name,
          originalMetadata.type,
        ];
      },
      enumerable: false,
      configurable: false,
    });
  
  
     Object.defineProperty(target.prototype, 'isComponentReplaced', {
      get: function() {
        if (!has(this, 'replacementComponentInitialized')) {
          return !(inject(DisableReplacementDirective, { optional: true })) && inject(ReplaceableConfigService).getReplaceable(this['componentDescriptors']);
        } else {
          return this['replacementComponentInitialized'];
        }
      },
      enumerable: false, // Not visible in for...in loops
      configurable: false, // Cannot be redefined or deleted
    });
    
     return target;
   }
  }